exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer{\n    /* height: 50px;  */\n    height: auto;\n    padding: 1rem;\n    left: 0;\n    bottom: 0;\n    width: 100%;\n    display: block;\n    padding: 100px 0;\n    border-top: 1px #dedede solid;\n    background: #f7f7f7;\n\n  }\n  #footerText{\n    text-align: center;\n  }\n  .footerIcon{\n    height: 60px;\n  }", ""]);

// exports
